import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { selectorSetting } from "../../store/settings/selectors";
import { SETTING } from "../../utils/settings/constants";
import { getUrlImages } from "../../utils/url/url";
import useCookiesWithOptions from "../../hooks/useCookiesWithOptions";
import { COOKIE_KEY_THEME, getTheme } from "../../utils/theme/theme";

const PreloadIcon = React.memo(({ size = 200 }) => {
  const [cookie] = useCookiesWithOptions([COOKIE_KEY_THEME]);
  const themeMode = useSelector(selectorSetting(SETTING.themeMode.id));

  const fileName = getTheme(cookie.theme || themeMode).gifLoader;
  const path = getUrlImages() + "/" + fileName;

  let style;
  if (size) {
    style = {width: size, height: size * 1.1};
  }

  return (
    <img src={path} alt="Loading..." style={style} />
  );
});

PreloadIcon.propTypes = {
  size: PropTypes.number,
};

export default PreloadIcon;
